import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { concatMap, retryWhen, delay, delayWhen } from 'rxjs/operators';
import { Logger } from '../logger.service';

export const retryCount = 3;
export const retryWaitMilliSeconds = 1000;
export const codesForRetry = [506, 507, 508, 510, 511, 0];
// Long-running report calls: status 0 there usually means the proxy dropped a request the server is still
// computing, and a retry starts the whole computation again. Don't retry those on status 0.
const noRetryOnStatus0 = ['/kpis/v2'];
const log = new Logger('MonitorInterceptor');

@Injectable()
export class MonitorInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const skipStatus0 = noRetryOnStatus0.some((url) => request.url.includes(url));
    return next.handle(request).pipe(
      retryWhen((error) =>
        error.pipe(
          concatMap((error, count) => {
            const retryable = codesForRetry.includes(error.status) && !(skipStatus0 && error.status === 0);
            if (count < retryCount && retryable) {
              error.count = count;
              log.error(error);
              return of(error).pipe(delay(retryWaitMilliSeconds * (count + 1)));
            }
            return throwError(() => {
              return error;
            });
          })
        )
      )
    );
  }
}
